<template>
    <div class="vsl-page-standalone">
        <a :href="whatsappLink" target="_blank" class="whatsapp-float" :title="labelsState.vsl_whatsapp_float_title || 'Contactar por WhatsApp'">
            <svg viewBox="0 0 32 32" class="whatsapp-icon">
                <path fill="currentColor" d="M16 0C7.164 0 0 7.164 0 16c0 2.828.738 5.482 2.024 7.778L0 32l8.395-2.093A15.897 15.897 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.467 0-4.808-.667-6.808-1.827l-.488-.288-5.056 1.259 1.307-4.885-.32-.51A13.222 13.222 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.308-9.979c-.4-.2-2.368-1.169-2.735-1.302-.368-.134-.635-.2-.903.2-.267.4-1.035 1.302-1.269 1.569-.234.268-.468.301-.868.101-.4-.2-1.688-.622-3.215-1.983-1.188-1.059-1.99-2.366-2.224-2.766-.234-.4-.025-.617.175-.816.18-.179.4-.468.601-.701.2-.234.267-.4.4-.668.134-.267.067-.501-.033-.701-.101-.2-.903-2.176-1.237-2.979-.326-.782-.657-.676-.903-.689-.234-.012-.501-.015-.768-.015s-.702.101-1.069.501c-.368.4-1.403 1.371-1.403 3.344s1.437 3.879 1.637 4.146c.2.268 2.825 4.314 6.843 6.052.955.413 1.701.66 2.283.845.959.305 1.832.262 2.521.159.769-.115 2.368-.968 2.702-1.903.334-.935.334-1.736.234-1.903-.101-.168-.368-.268-.768-.468z"/>
            </svg>
        </a>

        <div class="language-selector-vsl">
            <button @click="toggleLanguageDropdown" class="language-btn">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                </svg>
            </button>
            <div v-if="showLanguageDropdown" class="language-dropdown-vsl">
                <ul>
                    <li v-for="code in languageCodes" :key="code" @click="changeLanguage(code)">
                        {{ code.toUpperCase() }}
                    </li>
                </ul>
            </div>
        </div>

        <div class="offer-banner">
            <div class="offer-banner__content">
                <div class="offer-icon">{{ labelsState.vsl_offer_icon || '🔥' }}</div>
                <div class="offer-text">
                    <span class="gradient-text-inline">{{ labelsState.vsl_offer_limited || 'LIMITED OFFER:' }}</span> {{ labelsState.vsl_offer_discount || 'Get' }} <span class="highlight">{{ labelsState.vsl_offer_percentage || '50% OFF' }}</span> {{ labelsState.vsl_offer_bonuses || '+ Free Bonuses Today' }}
                </div>
                <div class="offer-countdown">
                    <span class="countdown-label">{{ labelsState.vsl_countdown_label || 'Ends in:' }}</span>
                    <span class="countdown-value">{{ countdown.hours }}:{{ countdown.minutes }}:{{ countdown.seconds }}</span>
                </div>
            </div>
        </div>

        <main class="vsl-main">
            <div class="vsl-container">
                <section class="vsl-hero">
                    <h1 class="vsl-hero-title">
                        {{ labelsState.vsl_hero_title_one || '🚀 Discover The Exact System Used By The Most Successful Companies' }}
                        <span class="gradient-text">{{ labelsState.vsl_hero_title_two || 'To Multiply Their Sales x10' }}</span>
                    </h1>
                    <p class="vsl-hero-subtitle">
                        {{ labelsState.vsl_hero_subtitle_one || 'In the next' }} <span class="gradient-text-inline">{{ labelsState.vsl_hero_subtitle_minutes || '3 minutes' }}</span>, {{ labelsState.vsl_hero_subtitle_two || 'you will discover how more than' }} <span class="gradient-text-inline">{{ labelsState.vsl_hero_subtitle_companies || '2,847 companies' }}</span> {{ labelsState.vsl_hero_subtitle_three || 'are automating their customer service and closing sales 24/7 without hiring more staff' }}
                    </p>
                </section>

                <section class="vsl-video-section">
                    <div class="live-viewers">
                        <span class="live-dot"></span>
                        <span class="viewer-count">{{ liveViewers }} {{ labelsState.vsl_live_viewers || 'people watching now' }}</span>
                    </div>
                    
                    <div class="vsl-video-container">
                        <video 
                            ref="vslVideo" 
                            :poster="videoPoster"
                            class="vsl-video"
                            @timeupdate="updateProgress"
                            @play="onVideoPlay"
                            @pause="onVideoPause"
                            @ended="onVideoEnd"
                            controls
                            controlsList="nodownload"
                            autoplay
                            playsinline
                        >
                            <source src="@/assets/recording/vsl.mp4" type="video/mp4">
                            {{ labelsState.vsl_video_not_supported || 'Your browser does not support the video element.' }}
                        </video>
                        
                        <div class="vsl-progress-bar">
                            <div class="vsl-progress-fill" :style="{ width: videoProgress + '%' }"></div>
                        </div>

                        <div class="vsl-play-overlay" v-if="!hasStarted" @click="startVideo">
                            <div class="vsl-play-button">
                                <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M8 5v14l11-7z"/>
                                </svg>
                            </div>
                            <p class="vsl-play-text">{{ labelsState.vsl_play_video || '▶️ WATCH VIDEO NOW' }}</p>
                        </div>
                    </div>
                </section>

                <section class="vsl-main-cta-section">
                    <a :href="whatsappLink" target="_blank" class="main-cta-btn whatsapp-cta">
                        <span class="cta-icon-btn">
                            <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor">
                                <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.983 0-7.51 6.11-13.62 13.62-13.62s13.62 6.11 13.62 13.62c0 7.51-6.11 13.62-13.62 13.62zM21.305 19.26c-0.346-0.174-2.049-1.007-2.366-1.123-0.316-0.116-0.547-0.174-0.776 0.174s-0.893 1.123-1.094 1.347c-0.201 0.224-0.402 0.251-0.748 0.076-0.346-0.174-1.461-0.539-2.785-1.722-1.031-0.922-1.726-2.061-1.927-2.407-0.201-0.346-0.022-0.533 0.152-0.707 0.156-0.155 0.346-0.402 0.518-0.603 0.174-0.201 0.231-0.346 0.346-0.571 0.116-0.224 0.058-0.427-0.028-0.603s-0.776-1.87-1.063-2.565c-0.280-0.672-0.56-0.582-0.776-0.593-0.201-0.010-0.431-0.012-0.661-0.012s-0.603 0.085-0.92 0.427c-0.316 0.346-1.206 1.179-1.206 2.873s1.235 3.333 1.406 3.561c0.174 0.224 2.425 3.732 5.872 5.234 0.821 0.354 1.462 0.566 1.962 0.724 0.825 0.262 1.577 0.225 2.168 0.137 0.661-0.099 2.049-0.835 2.335-1.642 0.288-0.807 0.288-1.501 0.201-1.642-0.085-0.14-0.316-0.224-0.661-0.398z"/>
                            </svg>
                        </span>
                        <span class="cta-text-btn">{{ labelsState.vsl_cta_whatsapp || 'Contact via WhatsApp' }}</span>
                    </a>
                    <a :href="registerUrl" target="_blank" class="main-cta-btn primary-cta">
                        <span class="cta-icon-btn">{{ labelsState.vsl_cta_primary_icon || '🤖' }}</span>
                        <span class="cta-text-btn">{{ labelsState.vsl_cta_primary || 'I Want My Chatbot!' }}</span>
                    </a>
                </section>

                <section class="vsl-guarantee-section">
                    <div class="guarantee-box">
                        <div class="guarantee-icon">{{ labelsState.vsl_guarantee_icon || '🛡️' }}</div>
                        <div class="guarantee-content">
                            <h3>{{ labelsState.vsl_guarantee_title || 'Total Satisfaction Guarantee for 30 Days' }}</h3>
                            <p>
                                {{ labelsState.vsl_guarantee_text_one || 'If you are not' }} <span class="gradient-text-inline">{{ labelsState.vsl_guarantee_satisfied || '100% satisfied' }}</span> {{ labelsState.vsl_guarantee_text_two || 'with the results, we will refund' }} <span class="gradient-text-inline">{{ labelsState.vsl_guarantee_money || 'all your money' }}</span>. {{ labelsState.vsl_guarantee_text_three || 'No questions, no complications. You have' }} <span class="gradient-text-inline">{{ labelsState.vsl_guarantee_days || '30 full days' }}</span> {{ labelsState.vsl_guarantee_text_four || 'to try our platform without any risk.' }}
                            </p>
                        </div>
                    </div>
                </section>

                <section class="vsl-testimonials-section">
                    <h2 class="testimonials-title">{{ labelsState.vsl_testimonials_title || '⭐ What Our +2,000 Satisfied Customers Say' }}</h2>
                    <div class="testimonials-carousel">
                        <div class="carousel-container">
                            <div class="carousel-track" :style="{ transform: `translateX(-${currentTestimonial * 33.333}%)` }">
                                <div class="carousel-slide" v-for="(image, idx) in testimonialImages" :key="idx">
                                    <img :src="image" :alt="`Testimonio ${idx + 1}`" class="testimonial-image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="vsl-contact-section">
                    <div class="contact-header">
                        <h2 class="contact-title">{{ labelsState.vsl_contact_title || '💬 Have Any Questions? We Are Here To Help You' }}</h2>
                        <p class="contact-subtitle">
                            {{ labelsState.vsl_contact_response || 'Our team of experts responds in' }} <span class="gradient-text-inline">{{ labelsState.vsl_contact_time || 'less than 2 hours' }}</span>
                        </p>
                    </div>
                    <form class="contact-form" @submit.prevent="submitForm">
                        <input 
                            type="text" 
                            v-model="formData.name" 
                            :placeholder="labelsState.vsl_form_name_placeholder || 'Your full name'" 
                            class="form-input" 
                            required
                        >
                        <input 
                            type="email" 
                            v-model="formData.email" 
                            :placeholder="labelsState.vsl_form_email_placeholder || 'Your email'" 
                            class="form-input" 
                            required
                        >
                        <input 
                            type="tel" 
                            v-model="formData.phone" 
                            :placeholder="labelsState.vsl_form_phone_placeholder || 'Your WhatsApp number'" 
                            class="form-input"
                            required
                        >
                        <button type="submit" class="form-submit-btn" :disabled="isSubmitting">
                            <span v-if="!isSubmitting">📤 {{ labelsState.vsl_form_submit_btn || 'Send Message' }}</span>
                            <span v-else>{{ labelsState.vsl_form_sending || 'Sending...' }}</span>
                        </button>
                    </form>
                </section>

                <section class="vsl-trust-section">
                    <div class="trust-badges">
                        <div class="trust-badge">
                            <span class="trust-icon">{{ labelsState.vsl_trust_secure_icon || '🔒' }}</span>
                            <span class="trust-text">{{ labelsState.vsl_trust_secure || '100% Secure Payment' }}</span>
                        </div>
                        <div class="trust-badge">
                            <span class="trust-icon">{{ labelsState.vsl_trust_verified_icon || '✅' }}</span>
                            <span class="trust-text">{{ labelsState.vsl_trust_verified || 'Verified Company' }}</span>
                        </div>
                        <div class="trust-badge">
                            <span class="trust-icon">{{ labelsState.vsl_trust_rating_icon || '⭐' }}</span>
                            <span class="trust-text">{{ labelsState.vsl_trust_rating || 'Rating 4.9/5' }}</span>
                        </div>
                        <div class="trust-badge">
                            <span class="trust-icon">{{ labelsState.vsl_trust_no_commitment_icon || '💳' }}</span>
                            <span class="trust-text">{{ labelsState.vsl_trust_no_commitment || 'No Commitment' }}</span>
                        </div>
                        <div class="trust-badge">
                            <span class="trust-icon">{{ labelsState.vsl_trust_leaders_icon || '🏆' }}</span>
                            <span class="trust-text">{{ labelsState.vsl_trust_leaders || 'Industry Leaders' }}</span>
                        </div>
                        <div class="trust-badge">
                            <span class="trust-icon">{{ labelsState.vsl_trust_instant_icon || '⚡' }}</span>
                            <span class="trust-text">{{ labelsState.vsl_trust_instant || 'Instant Access' }}</span>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </div>
</template>

<script>
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';
import { computed, ref } from 'vue';
import axios from 'axios';

export default {
    name: "LSVCompactNew",
    setup() {
        const labelsStore = useLabelsStore();
        const languageStore = useLanguageStore();
        const showLanguageDropdown = ref(false);
        const currentLanguage = computed(() => languageStore.language);

        const changeLanguage = (languageCode) => {
            languageStore.setLanguage(languageCode);
            labelsStore.fetchAndSetLabels(languageCode);
            showLanguageDropdown.value = false;
        };

        const toggleLanguageDropdown = () => {
            showLanguageDropdown.value = !showLanguageDropdown.value;
        };

        const labelsState = computed(() => labelsStore.labels);
        const languageCodes = computed(() => languageStore.codes);

        return {
            labelsState,
            languageCodes,
            changeLanguage,
            showLanguageDropdown,
            toggleLanguageDropdown,
            currentLanguage,
        };
    },
    data() {
        return {
            videoProgress: 0,
            hasStarted: true,
            isPlaying: false,
            isSubmitting: false,
            videoPoster: require('@/assets/images/dashboard.png'),
            videoDuration: '3:45',
            viewsCount: 2847,
            liveViewers: 47,
            formData: {
                name: '',
                email: '',
                phone: ''
            },
            countdown: {
                hours: '23',
                minutes: '59',
                seconds: '59'
            },
            whatsappNumber: '+573001234567',
            whatsappMessage: 'Hola! Vi el video y quiero más información sobre NQA 🚀',
            currentTestimonial: 0,
            testimonialImages: [
                require('@/assets/images/testimonial/1.png'),
                require('@/assets/images/testimonial/2.png'),
                require('@/assets/images/testimonial/3.png'),
                require('@/assets/images/testimonial/1.png'),
                require('@/assets/images/testimonial/2.png'),
                require('@/assets/images/testimonial/3.png'),
                require('@/assets/images/testimonial/1.png')
            ],
            carouselInterval: null
        };
    },
    computed: {
        whatsappLink() {
            const message = encodeURIComponent(this.whatsappMessage);
            return `https://wa.me/${this.whatsappNumber}?text=${message}`;
        },
        registerUrl() {
            return 'https://dashboard.nqartificial.com/chatbots/chatbots_general';
        }
    },
    mounted() {
        this.loadCompanyInfo();
        this.startCountdown();
        this.startLiveViewersCounter();
        this.startCarousel();
    },
    methods: {
        async loadCompanyInfo() {
            try {
                const response = await axios.get(
                    `${process.env.VUE_APP_HOST_MANAGEMENT}/languages`,
                    { withCredentials: true, timeout: 90000 }
                );
                
                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                    const languageData = response.data[0];
                    if (languageData.text) {
                        if (languageData.text.message_vsl) {
                            this.whatsappMessage = languageData.text.message_vsl;
                        }
                        if (languageData.text.number_to_vsl) {
                            this.whatsappNumber = languageData.text.number_to_vsl;
                        }
                    }
                }
            } catch (error) {
            }
        },
        startVideo() {
            if (this.$refs.vslVideo) {
                this.$refs.vslVideo.play();
                this.hasStarted = true;
                this.isPlaying = true;
            }
        },
        updateProgress() {
            if (this.$refs.vslVideo) {
                const progress = (this.$refs.vslVideo.currentTime / this.$refs.vslVideo.duration) * 100;
                this.videoProgress = progress;
            }
        },
        onVideoPlay() {
            this.isPlaying = true;
        },
        onVideoPause() {
            this.isPlaying = false;
        },
        onVideoEnd() {
        },
        async submitForm() {
            this.isSubmitting = true;
            
            try {
                let message;
                if (this.currentLanguage === 'es') {
                    message = `¡Hola! Soy ${this.formData.name} y estoy interesado en adquirir un chatbot.\nMi correo es ${this.formData.email} y mi número de whatsapp es ${this.formData.phone}`;
                } else {
                    message = `Hello! I'm ${this.formData.name} and I'm interested in getting a chatbot.\nMy email is ${this.formData.email} and my WhatsApp number is ${this.formData.phone}`;
                }
                
                const encodedMessage = encodeURIComponent(message);
                const whatsappUrl = `https://wa.me/${this.whatsappNumber}?text=${encodedMessage}`;
                
                window.open(whatsappUrl, '_blank');
                
            } catch (error) {
                console.error('Error submitting form:', error);
                alert(this.currentLanguage === 'es' ? 'Hubo un error. Por favor intenta de nuevo.' : 'There was an error. Please try again.');
            } finally {
                this.isSubmitting = false;
            }
        },
        startCountdown() {
            let totalSeconds = 23 * 3600 + 59 * 60 + 59;
            
            setInterval(() => {
                totalSeconds--;
                
                if (totalSeconds <= 0) {
                    totalSeconds = 24 * 3600;
                }
                
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;
                
                this.countdown.hours = String(hours).padStart(2, '0');
                this.countdown.minutes = String(minutes).padStart(2, '0');
                this.countdown.seconds = String(seconds).padStart(2, '0');
            }, 1000);
        },
        startLiveViewersCounter() {
            const updateViewers = () => {
                const change = Math.random() > 0.5 ? 
                    Math.floor(Math.random() * 3) + 1 :
                    -Math.floor(Math.random() * 2);
                
                this.liveViewers = Math.max(35, Math.min(67, this.liveViewers + change));
                const nextUpdate = (Math.random() * 5000) + 3000;
                setTimeout(updateViewers, nextUpdate);
            };
            
            updateViewers();
        },
        prevTestimonial() {
            if (this.currentTestimonial > 0) {
                this.currentTestimonial--;
            }
        },
        nextTestimonial() {
            if (this.currentTestimonial < this.testimonialImages.length - 3) {
                this.currentTestimonial++;
            } else {
                this.currentTestimonial = 0;
            }
        },
        goToTestimonial(index) {
            this.currentTestimonial = index;
        },
        startCarousel() {
            this.carouselInterval = setInterval(() => {
                this.nextTestimonial();
            }, 4000);
        }
    },
    beforeUnmount() {
        if (this.carouselInterval) {
            clearInterval(this.carouselInterval);
        }
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.vsl-page-standalone {
    background: linear-gradient(135deg, #192337 0%, #111827 50%, #0e1726 100%);
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.vsl-page-standalone::-webkit-scrollbar {
    width: 12px;
}

.vsl-page-standalone::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.3);
}

.vsl-page-standalone::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #00CC99 0%, #003366 100%);
    border-radius: 10px;
    border: 2px solid rgba(0, 0, 0, 0.3);
}

.vsl-page-standalone::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #003366 0%, #00CC99 100%);
}

.whatsapp-float {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.5);
    z-index: 9999;
    transition: all 0.3s ease;
    animation: pulse 2s infinite;
}

.whatsapp-float:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 30px rgba(37, 211, 102, 0.7);
}

.whatsapp-icon {
    width: 35px;
    height: 35px;
    color: #fff;
}

@keyframes pulse {
    0%, 100% {
        box-shadow: 0 4px 20px rgba(37, 211, 102, 0.5);
    }
    50% {
        box-shadow: 0 4px 30px rgba(37, 211, 102, 0.8);
    }
}

.language-selector-vsl {
    position: fixed;
    top: 90px;
    right: 30px;
    z-index: 9998;
}

.language-btn {
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #00CC99 0%, #003366 100%);
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 20px rgba(0, 204, 153, 0.4);
    transition: all 0.3s ease;
    color: #fff;
}

.language-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 30px rgba(0, 204, 153, 0.6);
}

.language-dropdown-vsl {
    position: absolute;
    top: 60px;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 10px;
    padding: 10px 0;
    min-width: 100px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.language-dropdown-vsl ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.language-dropdown-vsl li {
    padding: 10px 20px;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    font-weight: 600;
}

.language-dropdown-vsl li:hover {
    background: linear-gradient(90deg, #00CC99 0%, #003366 95.62%);
}

.offer-banner {
    background: linear-gradient(90deg, #00CC99 0%, #003366 95.62%);
    padding: 10px 15px;
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: 0 4px 20px rgba(0, 51, 102, 0.5);
}

.offer-banner__content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
}

.offer-icon {
    font-size: 22px;
    animation: bounce 1s infinite;
}

@keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-8px); }
}

.offer-text {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
}

.highlight {
    background: rgba(255, 255, 255, 0.3);
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 900;
}

.offer-countdown {
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(0, 0, 0, 0.3);
    padding: 8px 15px;
    border-radius: 20px;
}

.countdown-label {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

.countdown-value {
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    font-family: 'Courier New', monospace;
}

.vsl-main {
    padding: 20px 20px;
}

.vsl-container {
    max-width: 1000px;
    margin: 0 auto;
}

.vsl-hero {
    text-align: center;
    margin-bottom: 25px;
}

.vsl-hero-title {
    font-size: 24px;
    font-weight: 900;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 15px;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.gradient-text {
    display: block;
    background: linear-gradient(225deg, #00CC99 0%, #003366 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-top: 8px;
}

.gradient-text-inline {
    background: linear-gradient(225deg, #00CC99 0%, #003366 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 900;
    font-size: 1.1em;
}

.vsl-hero-subtitle {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.5;
    margin-bottom: 20px;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
}

.vsl-video-section {
    margin-bottom: 30px;
}

.live-viewers {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 15px;
    padding: 10px 20px;
    background: rgba(220, 38, 38, 0.15);
    border: 1px solid rgba(220, 38, 38, 0.4);
    border-radius: 25px;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
}

.live-dot {
    width: 10px;
    height: 10px;
    background: #ef4444;
    border-radius: 50%;
    animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(239, 68, 68, 0);
    }
}

.viewer-count {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

.vsl-video-container {
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 0 auto 20px;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.vsl-video {
    width: 100%;
    display: block;
    background: #000;
}

.vsl-progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 12px;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10;
}

.vsl-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
    transition: width 0.3s ease;
    box-shadow: 0 0 20px rgba(239, 68, 68, 0.8), 0 0 40px rgba(239, 68, 68, 0.4);
    position: relative;
}

.vsl-progress-fill::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%);
    animation: shine 2s infinite;
}

@keyframes shine {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
}

.vsl-play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 5;
    transition: all 0.3s ease;
}

.vsl-play-overlay:hover {
    background: rgba(0, 0, 0, 0.7);
}

.vsl-play-button {
    width: 100px;
    height: 100px;
    background: linear-gradient(90deg, #00CC99 0%, #003366 95.62%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 40px rgba(0, 204, 153, 0.6);
    transition: all 0.3s ease;
    margin-bottom: 15px;
}

.vsl-play-overlay:hover .vsl-play-button {
    transform: scale(1.1);
    box-shadow: 0 15px 50px rgba(0, 204, 153, 0.8);
}

.vsl-play-button svg {
    color: #fff;
    margin-left: 5px;
}

.vsl-play-text {
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.vsl-video-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 20px;
    max-width: 700px;
    margin: 30px auto 0;
    padding: 0 20px;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    padding: 20px 15px;
    border-radius: 15px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    transition: all 0.3s ease;
}

.stat-item:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(0, 204, 153, 0.4);
}

.stat-icon {
    font-size: 32px;
}

.stat-text {
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 1.4;
}

.stat-text strong {
    display: block;
    font-size: 16px;
    font-weight: 900;
    background: linear-gradient(225deg, #00CC99 0%, #003366 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 2px;
}

.vsl-main-cta-section {
    margin: 40px auto;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 20px;
}

.main-cta-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 20px 40px;
    border-radius: 15px;
    font-size: 18px;
    font-weight: 700;
    text-decoration: none;
    letter-spacing: 0.3px;
    transition: all 0.3s ease;
    cursor: pointer;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    position: relative;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.main-cta-btn::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
}

.main-cta-btn:hover::before {
    width: 400px;
    height: 400px;
}

.primary-cta {
    background: linear-gradient(90deg, #00CC99 0%, #003366 95.62%);
    color: #fff;
    border: none;
}

.primary-cta:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 15px 50px rgba(0, 204, 153, 0.6);
}

.whatsapp-cta {
    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
    color: #fff;
    border: none;
    animation: pulse-glow 2s infinite;
}

.whatsapp-cta:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 15px 50px rgba(37, 211, 102, 0.6);
}

.cta-icon-btn {
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.cta-text-btn {
    z-index: 1;
    font-size: 17px;
    font-weight: 700;
    line-height: 1.3;
    color: #fff;
}

@keyframes pulse-glow {
    0%, 100% {
        box-shadow: 0 10px 40px rgba(37, 211, 102, 0.4);
    }
    50% {
        box-shadow: 0 10px 50px rgba(37, 211, 102, 0.8), 0 0 30px rgba(37, 211, 102, 0.4);
    }
}

.vsl-guarantee-section {
    margin-bottom: 50px;
}

.guarantee-box {
    display: flex;
    align-items: center;
    gap: 20px;
    background: linear-gradient(135deg, rgba(0, 204, 153, 0.2), rgba(0, 51, 102, 0.2));
    backdrop-filter: blur(10px);
    border: 2px solid rgba(0, 204, 153, 0.5);
    border-radius: 20px;
    padding: 30px;
}

.guarantee-icon {
    font-size: 42px;
}

.guarantee-content h3 {
    font-size: 17px;
    font-weight: 900;
    color: #fff;
    margin-bottom: 10px;
}

.guarantee-content p {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
}

.vsl-testimonials-section {
    margin-bottom: 50px;
}

.testimonials-title {
    font-size: 22px;
    font-weight: 900;
    color: #fff;
    text-align: center;
    margin-bottom: 30px;
}

.testimonials-carousel {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    max-width: 900px;
    margin: 0 auto;
}

.carousel-container {
    overflow: hidden;
    width: 100%;
    border-radius: 15px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    transform: scale(1.2);
    margin: 20px 0;
}

.carousel-track {
    display: flex;
    transition: transform 0.5s ease-in-out;
}

.carousel-slide {
    min-width: 33.333%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
}

.testimonial-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 15px;
}

.carousel-btn {
    background: linear-gradient(135deg, #00CC99 0%, #003366 100%);
    border: none;
    color: #fff;
    font-size: 48px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 20px rgba(0, 204, 153, 0.4);
    flex-shrink: 0;
}

.carousel-btn:hover:not(:disabled) {
    transform: scale(1.1);
    box-shadow: 0 6px 30px rgba(0, 204, 153, 0.6);
}

.carousel-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.carousel-indicators {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
}

.indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator:hover {
    background: rgba(255, 255, 255, 0.5);
}

.indicator.active {
    background: linear-gradient(135deg, #00CC99 0%, #003366 100%);
    width: 30px;
    border-radius: 6px;
}

.vsl-contact-section {
    margin-bottom: 50px;
}

.contact-header {
    text-align: center;
    margin-bottom: 30px;
}

.contact-title {
    font-size: 22px;
    font-weight: 900;
    color: #fff;
    margin-bottom: 10px;
}

.contact-subtitle {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.9);
}

.contact-form {
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
}

.form-input,
.form-textarea {
    width: 100%;
    padding: 15px 20px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    color: #fff;
    font-size: 15px;
    transition: all 0.3s ease;
}

.form-input::placeholder,
.form-textarea::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.form-input:focus,
.form-textarea:focus {
    outline: none;
    border-color: rgba(0, 204, 153, 0.6);
    background: rgba(255, 255, 255, 0.2);
}

.form-submit-btn {
    padding: 18px;
    background: linear-gradient(90deg, #00CC99 0%, #003366 95.62%);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 16px;
    font-weight: 900;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 30px rgba(0, 51, 102, 0.4);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-submit-btn:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 12px 40px rgba(0, 204, 153, 0.6);
}

.form-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.vsl-trust-section {
    margin-bottom: 50px;
}

.trust-badges {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

.trust-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 15px;
    padding: 15px 20px;
    transition: all 0.3s ease;
}

.trust-badge:hover {
    transform: translateY(-5px);
    border-color: rgba(255, 255, 255, 0.4);
}

.trust-icon {
    font-size: 30px;
}

.trust-text {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
}

@media (max-width: 768px) {
    .vsl-main {
        padding: 15px 15px;
    }
    
    .vsl-hero-title {
        font-size: 20px;
    }
    
    .vsl-hero-subtitle {
        font-size: 12px;
    }
    
    .vsl-video-container {
        max-width: 100%;
    }
    
    .live-viewers {
        font-size: 11px;
        padding: 8px 15px;
    }
    
    .vsl-video-stats {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }
    
    .stat-icon {
        font-size: 24px;
    }
    
    .stat-text {
        font-size: 11px;
    }
    
    .stat-text strong {
        font-size: 14px;
    }
    
    .vsl-main-cta-section {
        gap: 15px;
    }
    
    .main-cta-btn {
        padding: 16px 30px;
        font-size: 14px;
    }
    
    .cta-text-btn {
        font-size: 14px;
    }
    
    .cta-icon-btn {
        font-size: 24px;
    }
    
    .offer-banner__content {
        flex-direction: column;
        gap: 8px;
    }
    
    .offer-text {
        font-size: 12px;
    }
    
    .form-row {
        grid-template-columns: 1fr;
    }
    
    .guarantee-box {
        flex-direction: column;
        text-align: center;
    }
    
    .carousel-slide {
        min-width: 100%;
        padding: 0;
    }
    
    .carousel-btn {
        width: 50px;
        height: 50px;
        font-size: 36px;
    }
}
</style>
